var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgStatus = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnssvgjs: "http://svgjs.com/svgjs",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M27.431 40.049a16.578 16.578 0 0 1-3.431.357c-9.107 0-16.5-7.393-16.5-16.5 0-1.379-1.12-2.5-2.5-2.5s-2.5 1.121-2.5 2.5c0 11.867 9.634 21.5 21.5 21.5 1.531 0 3.025-.16 4.466-.465a2.501 2.501 0 0 0-1.035-4.892zm-1.106-32.48c8.008 1.13 14.175 8.02 14.175 16.337 0 5.884-3.087 11.053-7.728 13.975a2.5 2.5 0 0 0 2.664 4.231C41.481 38.305 45.5 31.571 45.5 23.906c0-10.839-8.04-19.815-18.476-21.288-1.366-.193-2.632.76-2.825 2.126s.76 2.632 2.126 2.825zM8.687 17.752a16.57 16.57 0 0 1 9.854-9.42 2.5 2.5 0 0 0-1.656-4.718 21.585 21.585 0 0 0-12.836 12.27 2.5 2.5 0 0 0 4.638 1.868z",
    fill: "#242d3d",
    "data-original": "#16191f",
    className: ""
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStatus, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/status.bf4f6f0c.svg";
export { ForwardRef as ReactComponent };